<template>
  <div>
    <h6 v-if="errorMessage != ''" class="text-danger">
      {{ errorMessage }}
    </h6>
    <transition name="slide-fade" mode="out-in">
      <form v-if="page == 1" @submit.prevent="submitTemplate()" key="name">
        <div class="form-group">
          <label for="name">Template Name</label>
          <input
            type="text"
            class="form-control"
            id="name"
            placeholder="Name"
            v-model="newTemplateName"
            required
          />
        </div>
        <div class="text-left">
          <label>Score Inputs</label>
        </div>
        <div v-if="newTemplateInputs.length == 0">
          <label
            >There are no score inputs. Add a score input to start your
            template.</label
          >
        </div>
        <div
          v-for="input in newTemplateInputs.slice().sort($orderByOrder)"
          :key="input.Order"
        >
          <div class="form-row">
            <div class="col-auto">
              <i
                class="material-icons d-block pointer"
                v-on:click="orderUp(input)"
                >keyboard_arrow_up</i
              >
              {{ input.Order }}
              <i
                class="material-icons d-block pointer"
                v-on:click="orderDown(input)"
                >keyboard_arrow_down</i
              >
            </div>
            <div class="col">
              <div class="form-group">
                <div class="form-row">
                  <div class="col-auto mx-0">
                    <i
                      class="material-icons d-block pointer"
                      v-on:click="editInput(input)"
                      >edit</i
                    >
                  </div>
                  <div class="col-auto">
                    <label v-bind:for="'request' + input.Order">{{
                      $getScoreTemplateInputSummary(input)
                    }}</label>
                  </div>
                  <div class="col-auto">
                    <button
                      class="btn btn-sm btn-danger"
                      type="button"
                      v-on:click="removeInput(input)"
                    >
                      Remove
                    </button>
                  </div>
                </div>
                <input
                  type="text"
                  class="form-control"
                  v-bind:id="'request' + input.Order"
                  placeholder="Ex. Words Per Minute, Accuracy Percentage, Score, etc."
                  v-model="input.Request"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="text-center my-2">
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            v-on:click="addScoreInput"
          >
            Add Score Input
          </button>
        </div>
        <div class="row">
          <div class="col text-left">
            <button
              type="button"
              class="btn btn-primary"
              v-on:click="$emit('cancel-creator')"
            >
              Cancel
            </button>
          </div>
          <div class="col-auto">
            <button type="submit" class="btn btn-primary">
              {{
                ScoreTemplate != null ? "Update Template" : "Create Template"
              }}
            </button>
          </div>
        </div>
      </form>
      <div v-if="page == 2" key="inputtype" class="text-left">
        <button
          v-for="inputType in templateInputTypes.slice().sort($orderByOrder)"
          :key="inputType.Score_Template_Input_Type_Id"
          class="btn btn-primary mb-1"
          style="width: 100%"
          v-on:click="selectInputType(inputType)"
        >
          <strong>{{ inputType.Title }}</strong>
          <small class="d-block">{{ inputType.Description }}</small>
        </button>
        <button class="btn btn-primary mt-2" v-on:click="backToInitial">
          Back
        </button>
      </div>
      <div v-if="page == 3" key="inputinfo">
        <div class="form-group">
          <label for="request">Qustion/Information Request</label>
          <input
            type="text"
            class="form-control"
            id="request"
            placeholder="Ex. Words Per Minute, Accuracy Percentage, Score, etc."
            v-model="newTemplateInput.Request"
            required
          />
        </div>
        <div
          v-if="
            newTemplateInput.Score_Template_Input_Type
              .Score_Template_Input_Type_Id == 1
          "
        >
          <ScoreOutOf
            v-bind:InputData="this.newTemplateInput.Input_Data"
            @input-data-change="inputDataChange"
          />
        </div>
        <div
          v-if="
            newTemplateInput.Score_Template_Input_Type
              .Score_Template_Input_Type_Id == 3
          "
        >
          <NumberScale
            v-bind:InputData="this.newTemplateInput.Input_Data"
            @input-data-change="inputDataChange"
          />
        </div>
        <div
          v-if="
            newTemplateInput.Score_Template_Input_Type
              .Score_Template_Input_Type_Id == 4
          "
        >
          <MultipleChoice
            v-bind:InputData="this.newTemplateInput.Input_Data"
            @input-data-change="inputDataChange"
          />
        </div>
        <div class="row text-left">
          <div class="col">
            <button class="btn btn-primary mt-2" v-on:click="backFromLast">
              Back
            </button>
          </div>
          <div class="col-auto">
            <button class="btn btn-primary mt-2" v-on:click="addInput">
              {{
                this.templateInputToEdit != null ? "Update Input" : "Add Input"
              }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import $ from "jquery";
import ScoreOutOf from "@/components/Score/ScoreInputData/ScoreOutOf.vue";
import NumberScale from "@/components/Score/ScoreInputData/NumberScale.vue";
import MultipleChoice from "@/components/Score/ScoreInputData/MultipleChoice.vue";

export default {
  components: {
    ScoreOutOf,
    NumberScale,
    MultipleChoice
  },
  props: {
    ScoreTemplateType: Number,
    OrganizationId: Number,
    ScoreTemplate: Object
  },
  async mounted() {
    var view = this;
    $("#addStudentModal").on("shown.bs.modal", function() {
      $("#name").focus();
    });
    view.templateInputTypes = await this.$getScoreTemplateInputTypes();
  },
  watch: {
    ScoreTemplate: function() {
      this.newTemplateInputs = [];
      if (this.ScoreTemplate != null) {
        this.newTemplateName = this.ScoreTemplate.Title;
        this.ScoreTemplate.Score_Template_Inputs.forEach(input => {
          this.newTemplateInputs.push({
            Request: input.Request,
            Order: input.Order,
            Input_Data: JSON.parse(input.Input_Data),
            Score_Template_Input_Type: input.Score_Template_Input_Type
          });
        });
        this.page = 1;
      }
    }
  },
  data() {
    return {
      newTemplateName: "",
      newTemplateInputs: [],
      newTemplateInput: null,
      templateInputTypes: [],
      templateInputToEdit: null,
      page: 1,
      errorMessage: "",
      editingScoretemplate: null
    };
  },
  methods: {
    backToInitial() {
      this.page = 1;
      this.templateInputToEdit = null;
    },
    backFromLast() {
      if (this.templateInputToEdit != null) {
        this.page = 1;
        this.templateInputToEdit = null;
      } else {
        this.page = 2;
      }
    },
    addScoreInput() {
      this.page = 2;
      this.errorMessage = "";
    },
    selectInputType(newTemplateType) {
      this.newTemplateInput = {
        Order:
          this.newTemplateInputs.length > 0
            ? Math.max(...this.newTemplateInputs.map(i => i.Order)) + 1
            : 1,
        Request: "",
        Input_Data: null,
        Score_Template_Input_Type: newTemplateType
      };
      this.page = 3;
    },
    inputDataChange(newInputData) {
      this.newTemplateInput.Input_Data = newInputData;
    },
    addInput() {
      if (this.templateInputToEdit != null) {
        var inputIndex = this.newTemplateInputs.findIndex(
          t => t.Order == this.templateInputToEdit.Order
        );
        this.$set(this.newTemplateInputs, inputIndex, this.newTemplateInput);
        this.templateInputToEdit = null;
      } else {
        this.newTemplateInputs.push(this.newTemplateInput);
      }
      this.newTemplateInput = null;
      this.page = 1;
    },
    orderUp(input) {
      var order = input.Order;
      var indexToMoveDown = this.newTemplateInputs.findIndex(
        i => i.Order == order
      );
      var indexToMoveUp = this.newTemplateInputs.findIndex(
        i => i.Order == order - 1
      );
      if (indexToMoveUp != -1 && indexToMoveDown != -1) {
        this.newTemplateInputs[indexToMoveUp].Order = order;
        this.newTemplateInputs[indexToMoveDown].Order = order - 1;
      }
    },
    orderDown(input) {
      var order = input.Order;
      var indexToMoveUp = this.newTemplateInputs.findIndex(
        i => i.Order == order
      );
      var indexToMoveDown = this.newTemplateInputs.findIndex(
        i => i.Order == order + 1
      );
      if (indexToMoveUp != -1 && indexToMoveDown != -1) {
        this.newTemplateInputs[indexToMoveUp].Order = order + 1;
        this.newTemplateInputs[indexToMoveDown].Order = order;
      }
    },
    async submitTemplate() {
      if (this.ScoreTemplate != null) {
        await this.updateTemplate();
      } else {
        await this.createTemplate();
      }
    },
    async createTemplate() {
      this.errorMessage = "";
      if (this.newTemplateInputs.length > 0) {
        $("#addEditUnitModal").modal("hide");
        this.$store.commit("updateLoading", true);
        var templateToCreate = {
          Title: this.newTemplateName,
          Organization_Id: this.OrganizationId,
          Score_Template_Type_Id: this.ScoreTemplateType
        };
        await this.$createScoreTemplate(templateToCreate).then(
          async newTemplate => {
            await this.$createScoreTemplateInputs(
              this.newTemplateInputs,
              newTemplate.Score_Template_Id
            ).then(newTemplateInputs => {
              newTemplate.Score_Template_Inputs = newTemplateInputs;
              this.$emit("added-score-template", newTemplate);
              this.$store.commit("updateLoading", false);
              $("#addEditUnitModal").modal("show");
            });
          }
        );
      } else {
        this.errorMessage = "Please add at least one input to keep data.";
      }
    },
    async updateTemplate() {
      $("#editScoreTemplateModal").modal("hide");
      this.$store.commit("updateLoading", true);
      var scoreTemplateToUpdate = this.ScoreTemplate;
      scoreTemplateToUpdate.Title = this.newTemplateName;
      await this.$updateScoreTemplate(scoreTemplateToUpdate);
      await this.$updateScoreTemplateInputs(
        this.newTemplateInputs,
        scoreTemplateToUpdate.Score_Template_Id
      );
      scoreTemplateToUpdate.Score_Template_Inputs = this.newTemplateInputs;
      this.$store.commit("updateLoading", false);
      this.$emit("template-updated", scoreTemplateToUpdate);
    },
    removeInput(input) {
      var inputsToReduce = this.newTemplateInputs.filter(
        i => i.Order > input.Order
      );
      this.newTemplateInputs = this.newTemplateInputs.filter(
        t => t.Order != input.Order
      );
      inputsToReduce.sort(this.$orderByOrder).forEach(input => {
        var inputIndex = this.newTemplateInputs.findIndex(
          i => i.Order == input.Order
        );
        this.newTemplateInputs[inputIndex].Order -= 1;
      });
    },
    editInput(input) {
      this.templateInputToEdit = input;
      this.newTemplateInput = input;
      this.page = 3;
    }
  }
};
</script>
